import { ColumnInfo, ColumnType } from '@/Types';
import { DocumentInfoForEmailModel } from '@/Models/DocumentInfoModel';
import { useLocalization } from '@/Hooks';
import { useMemo } from 'react';

export function useSelectDocumentTableColumnInfo() {
  const {
    modalWindows: {
      documentPrintModal: { Columns },
    },
  } = useLocalization();

  return useMemo<ColumnInfo<DocumentInfoForEmailModel>[]>(
    () => [
      {
        columnType: ColumnType.String,
        fieldName: 'documentNumber',
        alignment: 'left',
        headerText: Columns.DocumentNumber,
      },
      {
        columnType: ColumnType.Date,
        fieldName: 'fileDateCreated',
        alignment: 'left',
        headerText: Columns.CreatedDate,
      },
      {
        columnType: ColumnType.Date,
        fieldName: 'documentDate',
        alignment: 'left',
        headerText: Columns.DocumentDate,
      },
    ],
    [Columns],
  );
}
